import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetPresignedDownloadURLForEmailCycleRecipientsRPC } from "./getPresignedDownloadUrlForEmailCycleRecipientsRPC";

export class GetPresignedDownloadURLForEmailCycleRecipientsRPCClientImpl extends GetPresignedDownloadURLForEmailCycleRecipientsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetPresignedDownloadURLForEmailCycleRecipientsRPC.Request): Promise<LeoRPCResult<GetPresignedDownloadURLForEmailCycleRecipientsRPC.Response, GetPresignedDownloadURLForEmailCycleRecipientsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/GetPresignedDownloadURLForEmailCycleRecipients",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetPresignedDownloadURLForEmailCycleRecipientsRPC.ResponseDTO,
      GetPresignedDownloadURLForEmailCycleRecipientsRPC.Errors.ErrorsDTO,
      GetPresignedDownloadURLForEmailCycleRecipientsRPC.Response,
      GetPresignedDownloadURLForEmailCycleRecipientsRPC.Errors.Errors
    >(
      response,
      "email-cycle/GetPresignedDownloadURLForEmailCycleRecipients",
      GetPresignedDownloadURLForEmailCycleRecipientsRPC.Response.fromDTO,
      GetPresignedDownloadURLForEmailCycleRecipientsRPC.Errors.fromDTO
    );
  }
}
